import { render, staticRenderFns } from "./photo-fundus.vue?vue&type=template&id=14f72f3b&scoped=true&"
import script from "./photo-fundus.vue?vue&type=script&lang=js&"
export * from "./photo-fundus.vue?vue&type=script&lang=js&"
import style0 from "./photo-fundus.vue?vue&type=style&index=0&id=14f72f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f72f3b",
  null
  
)

export default component.exports